import React, { useState } from "react"
import { usePagination } from "../../../hooks/usePagination"
import ResultHandler from "../../../components/ResultHandler"
import PaginationHandler from "../../../components/PaginationHandler"
import TableHeaderHandler from "../../../components/TableHeaderHandler"
import { useTranslation } from "react-i18next"
import TableAction from "../../../components/TableAction"
import EmptyData from "../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import { useResponse } from "../../../hooks/useResponse"
import DeleteModal from "../../../components/Common/DeleteModal"
import { Button, Col, Label, Row } from "reactstrap"
import { formatCurrency } from "../../../utils/formatCurrency"
import AssignReservationModal from "../../../components/reservation-modal/AssignReservationModal"
import { deleteCar, getCars } from "../../../api/cars"
import { ZoomImage } from "../../../components/zoom-image/ZoomImage"
import { useHistory } from "react-router-dom"
import TableFilter from "../../../components/TableFilter"
import DateFromTo from "../../../components/DateFromTo"

export default function CarsTable() {
  const { t } = useTranslation()
  const navigate = useHistory()

  const {
    response,
    loading,
    error,
    setPage,
    page,
    setPerPage,
    totalPages,
    setPayload,
    setMeta
  } = usePagination(getCars)

  // Filter
  const filterTypes = [
    {key: "license_plate", type: "text"},
    {key: "brand", type: "text"},
    {key: "type", type: "text"},
  ]

  const dateFields = [
    {key: "start", label: "Start Date"},
    {key: "end", label: "End Date"},
  ]


  // delete
  const [show, setShow] = useState(false)
  const [deletingCar, setDeletingCar] = useState(null)

  const { setData } = useResponse(deleteCar, () => {
    setShow(false)
    setDeletingCar(null)
    setPayload({ref: true})
  })

  function onDeleteClick() {
    setData({ type: "delete", data: deletingCar })
  }

  function onCloseClick() {
    setShow(false)
  }

  // Assign Car
  const [assignOpen, setAssignOpen] = useState(false)
  const [reservationEntity, setReservationEntity] = useState(null)

  
  return (
    <>
      <TableHeaderHandler
        permission={PERMISSIONS.CAR_CREATE}
        addUrl="/add-car"
        setPage={setPage}
        setPerPage={setPerPage}
      >
      </TableHeaderHandler>

      <TableFilter
        filterTypes={filterTypes}
        onFilter={(filters) => setMeta({ page: 1, payload: filters })}
      />

      <DateFromTo
        btnLabel="Serach for available Cars"
        dateFields={dateFields}
        onClick={(values) => setPayload(values)}
      />

      <div className="table-rep-plugin">
        <div className="table-responsive">
          <Table className="table table-striped table-bordered">
            <Thead className="table-light table-nowrap">
              <Tr>
                <Th>License plate</Th>
                <Th>Cost per day</Th>
                <Th>Cost of private use</Th>
                <Th>Picture</Th>
                <Th>Current renters</Th>
                <Th className="d-flex">{t("tables.Action")}</Th>
              </Tr>
            </Thead>

            {response.data && !loading && (
              <Tbody>
                {response.data.cars.map(row => {
                  return (
                    <Tr key={row.id}>
                      <Td>{row.license_plate}</Td>
                      <Td>{formatCurrency(row.cost_per_day)}</Td>
                      <Td>{formatCurrency(row.cost_of_private_use)} per kilometer</Td>
                      <Td>
                        {row.picture && <ZoomImage src={row.picture} alt="room image" width={150}/>}
                      </Td>
                      <Td>
                        <Button color="dark" size="sm" onClick={() => navigate.push(`/car-renters/${row.id}`)}>View</Button>
                      </Td>
                      <Td className="d-flex">
                        <TableAction
                          hasEdit={true}
                          editPermission={PERMISSIONS.CAR_EDIT}
                          hasDelete={true}
                          deletePermission={PERMISSIONS.CAR_DELETE}
                          type="car"
                          id={row.id}
                          setShow={setShow}
                          setDeleteIntitiy={setDeletingCar}
                        />
                        
                        <Button style={{marginLeft: "5px"}} color="dark" onClick={() => navigate.push('cars/'+row.id)}>
                          <i className="bx bxs-show font-size-16 align-middle" />
                        </Button>

                        {/* {row.status == 'available' && */}
                          <Button color="primary" style={{marginLeft: "5px"}} className="fw-bold" 
                            onClick={() => {
                              setAssignOpen(true)
                              setReservationEntity(row)
                            }}>
                            Assign
                          </Button>
                      </Td>
                    </Tr>
                  )
                })}
              </Tbody>
            )}
          </Table>

          {!loading &&
            <EmptyData empty={response.data && response.data.cars.length === 0} msg="No Cars Found." />
          }

          <DeleteModal
            show={show}
            onDeleteClick={onDeleteClick}
            onCloseClick={onCloseClick}
          />

          {response.data && !loading && (
            <PaginationHandler
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          )}
     
          <ResultHandler error={error} loading={loading} />

          {/* Assign */}
          {assignOpen && <AssignReservationModal
            type="car"
            entity={reservationEntity}
            show={assignOpen}
            handleClose={() => setAssignOpen(false)}
            handleRefetch={() => {
              setPayload({ref: true})
            }}
          />}
        </div>
      </div>
    </>
  )
}
